module.exports = __webpack_public_path__ + "static/media/orderedList.b94d7d5a.svg";